import type { Vec2 } from "./types";

const EDGE_PAN_ZONE_PX = 72;
const EDGE_PAN_MAX_STEP_PX = 5;

export function getEdgePanDelta(
  pointer: Vec2,
  size: { width: number; height: number },
  zone = EDGE_PAN_ZONE_PX,
  maxStep = EDGE_PAN_MAX_STEP_PX
): Vec2 {
  if (size.width <= 0 || size.height <= 0) return { x: 0, y: 0 };
  const left = Math.max(0, zone - pointer.x);
  const right = Math.max(0, zone - (size.width - pointer.x));
  const top = Math.max(0, zone - pointer.y);
  const bottom = Math.max(0, zone - (size.height - pointer.y));

  const ease = (distanceIntoZone: number) => {
    const t = Math.min(1, distanceIntoZone / zone);
    return t * t * maxStep;
  };

  return {
    x: left > 0 ? ease(left) : right > 0 ? -ease(right) : 0,
    y: top > 0 ? ease(top) : bottom > 0 ? -ease(bottom) : 0,
  };
}
